import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQueryWithReauth = baseUrl => {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: headers => {
      const token = localStorage.getItem('access_token')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    }
  })

  return async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions)

    if (result?.error?.status === 401) {
      const refreshToken = localStorage.getItem('refresh_token')
      if (refreshToken) {
        const refreshResult = await baseQuery(
          {
            url: '/users/token/refresh/',
            method: 'POST',
            body: { refresh: refreshToken }
          },
          api,
          extraOptions
        )

        if (refreshResult?.data) {
          const newAccessToken = refreshResult.data.access
          localStorage.setItem('access_token', newAccessToken)

          result = await baseQuery(args, api, extraOptions)
        } else {
          localStorage.removeItem('access_token')
          localStorage.removeItem('refresh_token')
          localStorage.removeItem('authUser')
          window.location.href = '/login'
        }
      } else {
        localStorage.removeItem('access_token')
        window.location.href = '/login'
      }
    }else if (result?.error?.status === 403) {
        // window.location.href = '/login'
    }

    return result
  }
}

export const createApiConfig = baseUrl => ({
  baseQuery: baseQueryWithReauth(baseUrl)
})
